(function (angular) {
    'use strict';

    angular.module('reports')
        .factory('messageDataService', [
            '$http', "portalConfig", "$q", function ($http, portalConfig, $q) {
                var urlBase = portalConfig.urlBase;
                var mockedData = [
                    {
                        "messageId": "0fb40138-6c25-44b1-9dcd-df73fa1971b4",
                        "submittedOn": "2018-08-07T14:36:37.617Z",
                        "profileId": "0e38b4dd-aca6-41ff-8fb1-ba1b531e45d2",
                        "phoneNumberCountryCode": "IE",
                        "fromProfileId": null,
                        "direction": "outbound",
                        "status": "queued",
                        "message": {
                            "title": null,
                            "body": "1. Test outbound message with a nice long string in it that keeps repeating",
                            "conversationId": null,
                            "customBody": null,
                            "messageParts": null,
                            "metadata": {
                                "comapiSystem": "smsApi"
                            },
                            "channelData": {
                                "sms": {
                                    "segmentCount": 2
                                }
                            }
                        },
                        "_createdOn": "2018-08-17T13:06:28.017Z",
                        "_createdBy": "system:stgbenmoore",
                        "channelId": "sms"
                    }, {
                        "messageId": "0fb40138-6c25-44b1-9dcd-df73fa1971b8",
                        "submittedOn": "2018-08-07T15:36:37.617Z",
                        "profileId": "0e38b4dd-aca6-41ff-8fb1-ba1b531e45d2",
                        "phoneNumberCountryCode": "IE",
                        "fromProfileId": null,
                        "direction": "outbound",
                        "status": "queued",
                        "message": {
                            "title": null,
                            "body": "1. Test outbound message with a nice long string in it that keeps repeating",
                            "conversationId": null,
                            "customBody": null,
                            "messageParts": null,
                            "metadata": {
                                "comapiSystem": "smsApi"
                            },
                            "channelData": {
                                "sms": {
                                    "segmentCount": 2
                                }
                            }
                        },
                        "_createdOn": "2018-08-17T13:06:28.017Z",
                        "_createdBy": "system:stgbenmoore",
                        "channelId": "sms"
                    }
                ];


                var fac = {
                    getQueriedMessageHistory: getQueriedMessageHistory,
                    getQueryString: getQueryString
                };
                return fac;
                function getQueryString(options, skip, limit, profileFilter) {
                    options.status = options.status ? "&status=" + options.status : "";
                    options.channel = options.channel ? "&channelId=" + options.channel : "";
                    options.direction = options.direction ? "&direction=" + options.direction : "";

                    var pf = "";
                    if (profileFilter && profileFilter.useSpecificProfiles && profileFilter.profileIds) {
                        profileFilter.profileIds.forEach(function (id) {
                            pf += ("&profileId=" + id);
                        });
                    }
                    var queryString;

                    if (!skip && !limit) {
                        queryString = "from=" +
                            options.from.toISOString() +
                            "&to=" + options.to.toISOString() +
                            options.channel +
                            options.status +
                            options.direction +
                            pf;
                    } else {
                        queryString = "from=" +
                            options.from.toISOString() +
                            "&to=" + options.to.toISOString() +
                            options.channel +
                            options.status +
                            options.direction +
                            "&skip=" + (skip || 0) +
                            "&limit=" + (limit || 10) +
                            pf;
                    }

                    return queryString;
                }

                function getQueriedMessageHistory(id, options, skip, limit, profileFilter) {

                    var url = urlBase + "/apispaces/" + id + "/messages/history?" +
                        getQueryString(options, skip, limit, profileFilter);

                    return $http.get(url)
                        .then(getQueriedDataComplete)
                        .catch(getQueriedDataFailed);

                    function getQueriedDataComplete(response) {
                        var count = parseInt(response.headers()["x-comapi-resultcount"]);

                        return { data: response.data, count: count };
                    }


                    function getQueriedDataFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }

                }

            }
        ]);
})(window.angular);